import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    num: '01',
    title: 'KIT EMPEZÁ HOY SIN BLOQUEARTE',
    desc: '10 prompts de supervivencia + orden ideal de uso + checklist "mañana tengo clase". Resultado hoy.',
    value: '12.000'
  }, {
    num: '02',
    title: 'MAPA DE ATAJOS PARA DOCENTES CON CERO TIEMPO',
    desc: '12 comandos docentes + tabla de decisión por urgencia. Usá la IA sin aprender más de lo que necesitás.',
    value: '10.000'
  }, {
    num: '03',
    title: 'BANCO DE RESPUESTAS RÁPIDAS PARA URGENCIAS',
    desc: '50 respuestas listas: Clase / Evaluación / Redacción / Comunicación / Institucional. Filtrables por tiempo.',
    value: '12.000'
  }, {
    num: '04',
    title: 'GUÍA EXPRESS PARA ADAPTAR MATERIAL EN 5 MINUTOS',
    desc: 'Framework A.R.M.A. + 8 scripts de IA. Nunca más rehacés algo que solo necesitaba un ajuste.',
    value: '10.000'
  }, {
    num: '05',
    title: 'CHECKLIST MAESTRA DE CLASES LISTAS',
    desc: '10 checklists + tracker semanal + modo 3 minutos. Entrá al aula con todo resuelto, no improvisando.',
    value: '10.000'
  }, {
    num: '06',
    title: 'PLAN ANTI-DOMINGO PARA DOCENTES AGOTADOS',
    desc: 'Rutina del Viernes (20 min) + Sistema de Decisión + Tracker de Calma. Recuperá tu domingo. Para siempre.',
    value: '10.000'
  }];
  return <section className="py-12 px-6 bg-nocheLight" data-id="element-30">
      <div className="max-w-7xl mx-auto" data-id="element-31">
        <div className="text-center mb-10" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-white flex items-center justify-center gap-3" data-id="element-33">
            <Gift className="w-8 h-8 text-naranja" data-id="element-34" />
            🎁 6 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-35">
          {bonos.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-noche rounded-2xl p-8 border border-petroleoLight relative" data-id="element-36">
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-naranja rounded-full flex items-center justify-center text-white font-bold text-xl border-4 border-nocheLight" data-id="element-37">
                {bono.num}
              </div>
              <h4 className="text-lg font-bold text-white mb-3 mt-2" data-id="element-38">
                {bono.title}
              </h4>
              <p className="text-gray-300 text-sm mb-6 flex-grow" data-id="element-39">
                {bono.desc}
              </p>
              <div className="pt-4 border-t border-petroleoLight mt-auto" data-id="element-40">
                <span className="text-gray-400 text-sm" data-id="element-41">
                  Valor: <span className="line-through" data-id="element-42">${bono.value}</span>
                </span>
                <span className="text-tealBrand font-bold ml-2" data-id="element-43">→ GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-petroleo border-2 border-tealBrand rounded-2xl p-6 text-center max-w-2xl mx-auto shadow-[0_0_30px_rgba(20,184,166,0.15)]" data-id="element-44">
          <p className="text-xl font-bold text-white" data-id="element-45">
            Valor total bonos:{' '}
            <span className="line-through text-gray-400" data-id="element-46">$64.000</span>{' '}
            <span className="text-tealBrand" data-id="element-47">→ GRATIS con tu MegaPack</span>
          </p>
        </motion.div>
      </div>
    </section>;
}